import { useFormikContext } from 'formik'
import {
  CreateLocationFormFieldProps,
  CreateLocationFromAgreementProps,
} from '../utility/types'
import { useMemo } from 'react'
import { getFormattedAddress } from '@sales-center/common'

export function useForm(params: CreateLocationFormFieldProps) {
  const {
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    values: { locations },
  } = useFormikContext<CreateLocationFromAgreementProps>()

  const location = useMemo(() => locations[params.location.id], [locations])

  const locationLabel = useMemo(() => {
    const formattedAddress = getFormattedAddress(
      location.address1 || '',
      location.address2 || '',
      location.city || '',
      location.state || '',
      location.postalCode || '',
    )
    const name =
      location.firstName || location.lastName
        ? `${location.firstName} ${location.lastName}`
        : location.company

    return formattedAddress ? formattedAddress : name
  }, [location, getFormattedAddress])

  const [requireEmail, requirePhone, nameRequired] = useMemo(
    () => [
      location.phoneNumber?.trim() === '',
      !location.emailAddresses.find((x) => x.emailAddress?.trim() !== ''),
      location.company?.trim() === '' &&
        location.lastName?.trim() === '' &&
        location.firstName?.trim() === '',
    ],
    [location],
  )

  return {
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    locationLabel,
    location,
    requireEmail,
    requirePhone,
    nameRequired,
  }
}
